import { render, staticRenderFns } from "./partner-transporters.vue?vue&type=template&id=7b0f491b"
import script from "./partner-transporters.vue?vue&type=script&lang=js"
export * from "./partner-transporters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports